<template>
  <div class="home_main" style="margin-top: -100px;">
    <div class="home_pic">
       <!-- 1. 添加 ref="videoPlayer" 和 playsinline -->
      <video 
        ref="videoPlayer"
        src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/websiteImg/20251220lsj.mp4" 
        class="full-bg-image" 
        autoplay 
        loop 
        muted 
        playsinline
      ></video>
    </div>
    <div class="home_pic" v-for="item in 6" :key="item">
      <img :src="getHomeImageUrl(item - 1)" alt="" class="full-bg-image"/> 
    </div>
  </div>
</template>

<script>
import { blhcImageCopy } from '@/utils/imageUtil';
import utils from '@/utils/util.js';

export default {
  name: "Home",
  data() {
    return {
      websiteImg: utils.websiteImg,
    };
  },
  // 针对正常跳转进入
  mounted() {
    this.forcePlayVideo();
  },
  // 针对被 keep-alive 缓存的组件再次进入
  activated() {
    this.forcePlayVideo();
  },
  methods: {
    blhcImageCopy,
    getHomeImageUrl(imgIndex) {
      const baseUrl = this.blhcImageCopy(`20251223home${imgIndex}.jpg`);
      const timestamp = Date.now();
      return `${baseUrl}?timestamp=${timestamp}`;
    },
    // 强制播放视频的方法
    forcePlayVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        // 确保它是静音的（非静音视频 100% 被浏览器拦截自动播放）
        video.muted = true;
        
        // play() 返回一个 promise
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.then(() => {
            console.log("视频自动播放成功");
          }).catch(error => {
            console.warn("视频自动播放被拦截，等待用户交互:", error);
            // 可以在此处监听一次 document 的点击事件，一旦点击就播放
            const triggerPlay = () => {
              video.play();
              document.removeEventListener('click', triggerPlay);
            };
            document.addEventListener('click', triggerPlay);
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.home_main {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.home_pic{
 width: 100%;
  height: 100vh;
  position: relative;
  line-height: 0;
  overflow: hidden;
}

.full-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.home_pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.home_pic .el-image {
  width: 100%;
  height: 100%;
  display: block;
  line-height: 0;
}

.top-nav{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
@media (max-width: 768px) {
  .home_pic{
    width: 100%;
    height: 100%;
  }
}
</style>
